import styled from 'styled-components'

import Container from '../Container/Container'
import Button from '../Button/Button'
import pxToRem from '../../utils/pxToRem'

export const StyledTabs = styled.div`
  display: flex;
`

export const StyledLocationCapacities = styled.div`
  justify-content: center;
  flex-direction: column;
  display: flex;
  width: 100%;
  max-width: ${pxToRem(792)};
  margin-bottom: ${pxToRem(30)};
`

export const StyledTabContent = styled(Container)`
  flex-direction: column;
  display: ${({ active }) => (active ? `flex` : 'none')};
  border-radius: 0 0 ${pxToRem(5)} ${pxToRem(5)};
  padding: ${pxToRem(22)} ${pxToRem(20.26)} ${pxToRem(10)} ${pxToRem(20.26)};
  background-color: ${({ theme }) => theme.colors.unique.white};
`

export const StyledButtonsContainer = styled.div`
  flex-wrap: wrap;
  justify-content: space-evenly;
  display: flex;
`

export const StyledTab = styled(Button)`
  flex: 1;
  justify-content: center;
  margin: 0;
  border: solid 2px ${({ theme }) => theme.colors.unique.transparent};
  border-radius: ${pxToRem(5)} ${pxToRem(5)} 0 0;
  padding: ${pxToRem(15)} 0;
  font-weight: ${({ theme }) => theme.fonts.weight.medium};
  ${({ active, theme }) =>
    active &&
    `
    border-bottom: solid 2px ${theme.colors.primary.blue};
    background-color: ${theme.colors.unique.white};
    `}
`

export const StyledRichText = styled.div`
  margin-bottom: 10px;
`
